module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Direction/images/battle.da7b855f.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Direction/images/battle.png
// module id = 2507
// module chunks = 11